module.exports = __webpack_public_path__ + "img/home-slider-bg-image.4a7b8ab8.jpg";